import axios from "@/axios"
const url = "/api/brain/warehouse/brands/"

class BrandsService {
	async getBrands(params) {
		try {
			const data = await axios.get(`${url}`, { params })
			return data.data
		} catch (error) {
			throw error
		}
	}

	async getBrandsSelect() {
		try {
			const data = await axios.get(`${url}select`)
			return data.data
		} catch (error) {
			throw error
		}
	}


	async addBrands(body) {
		try {
			const data = await axios.post(url + "save", body)
			return data
		} catch (error) {
			throw error
		}
	}

	async updateBrands(id, body) {
		try {
			const data = await axios.post(url + `${id}/` + "edit", body)
			return data
		} catch (error) {
			throw error
		}
	}

	async deleteBrands(id) {
		try {
			const data = await axios.delete(url + `${id}/` + "delete")
			return data
		} catch (error) {
			throw error
		}
	}
}

export default new BrandsService()
